import React, {ReactNode, Ref, RefAttributes, useCallback, useContext, useState} from "react";
import {Footer} from "../../paddlemate/Footer/Footer";
import {DashboardHeader} from "./DashboardHeader/DashboardHeader";
import styles from "./DashboardLayout.module.css";
import {DashboardNav} from "./DashboardNav/DashboardNav";

interface IDashboardLayout {
    children?: ReactNode;
    fullScreen?: boolean;
    scrollable?: boolean;
}

const DashboardLayout = ({children, scrollable = true, fullScreen = false}: IDashboardLayout) => {
    return (
        <div className={!fullScreen ? styles.container : styles.containerFullScreen}>
            {!fullScreen && <DashboardHeader/>}

            {scrollable && <div className={!fullScreen ? styles.overflowContainer : styles.overflowContainerFullScreen}>
                <div className={!fullScreen ? styles.contentContainer : styles.contentContainerFullScreen}>
                    {children}
                </div>
                {!fullScreen && <Footer/>}
            </div>}

            {!scrollable &&
                <div className={styles.contentContainerNotScrollable}>
                    {children}
                </div>}
        </div>
    );
};

export default DashboardLayout;
